// Daggerheart has no spell slots, no exhaustion track, no death saves and no
// level up/down wizard — its progression is handled on the sheet itself.
const capabilities = {
  homebrew: true,
  scoresAreModifiers: true, // trait values ARE the modifier — never (n-10)/2
};

export default capabilities;
